import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CardMedia from '@mui/material/CardMedia';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { InformationStack } from '../../../components/stacks';
import { getCdnUrl } from '../../../helpers';
import {
  STACK_CENTER_COLUMN_DIRECTION,
  INFORMATION_STACK_WITH_BORDER,
} from '../../../constants/mui-components';
import {
  productHeroContainer,
  heroContentStack,
  textContentStack,
  headerStack,
  titleContainer,
  titleTypography,
  subtitleTypography,
  normalImageContainer,
  smallImageContainer,
  imageStyles,
} from '../styles/product-hero.styles';
import RegisterButton from '../../../components/buttons/RegisterButton';
import { smallImageProducts } from '../../../constants/products/product-enum';

function ProductHero({ productData }) {
  const theme = useTheme();
  return (
    <Stack
      className={STACK_CENTER_COLUMN_DIRECTION}
      sx={productHeroContainer}
    >
      <Stack sx={heroContentStack}>
        <Stack sx={textContentStack}>
          <Stack sx={headerStack}>
            <InformationStack
              className={INFORMATION_STACK_WITH_BORDER}
              text={productData.name.toUpperCase()}
              backgroundColor={theme.palette.neutral.A700}
              textColor={theme.palette.common.white}
              variant="info_stack"
              fontWeight={800}
            />
            <Stack
              className={STACK_CENTER_COLUMN_DIRECTION}
              sx={titleContainer}
            >
              <Typography variant="xlarge_2" sx={titleTypography}>
                {productData.titleText}
              </Typography>
              <Typography variant="medium_2" sx={subtitleTypography}>
                {productData.subtitleText}
              </Typography>
            </Stack>
          </Stack>
          <RegisterButton
            text={productData.startTextButton}
            typographyVariant="small_3"
            sx={{ gap: '0.5rem', marginBottom: '3rem' }}
          />
        </Stack>
        <Box sx={smallImageProducts.includes(productData.name.toLowerCase())
          ? smallImageContainer : normalImageContainer}
        >
          <CardMedia
            component="img"
            image={getCdnUrl(productData.hero_image)}
            alt="product_hero"
            style={imageStyles}
          />
        </Box>
      </Stack>
    </Stack>
  );
}

ProductHero.propTypes = {
  productData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    titleText: PropTypes.string.isRequired,
    subtitleText: PropTypes.string.isRequired,
    startTextButton: PropTypes.string.isRequired,
    hero_image: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProductHero;
